import moment from 'moment';
// 一个副作用的import，如果不加antd的中文主题不生效
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
